<template>
  <div class="main-container-details">
    <!-- Pricing Section -->
    <section class="pricing-section">
      <div class="pricing-container">
        <!-- Image Showcase Section -->
        <div class="image-showcase-section">
          <div class="showcase-header">
            <h2 class="showcase-title">Explora Fourin Track en Detalle</h2>
            <p class="showcase-subtitle">
              Descubre cada módulo de nuestra plataforma de gestión de activos
            </p>
          </div>

          <div class="showcase-content">
            <!-- Navigation Tabs -->
            <div class="showcase-tabs">
              <button
                v-for="(module, index) in modules"
                :key="index"
                class="tab-button"
                :class="{ active: currentModule === index }"
                @click="setCurrentModule(index)"
              >
                <span class="tab-icon material-symbols-outlined">{{ module.icon }}</span>
                <span class="tab-label">{{ module.name }}</span>
              </button>
            </div>

            <!-- Image Display -->
            <div class="showcase-display" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
              <div class="image-container">
                <img
                  :src="modules[currentModule].image"
                  :alt="modules[currentModule].name"
                  class="showcase-image"
                  @load="onImageLoad"
                />
                <div class="image-overlay">
                  <div class="overlay-content">
                    <h3 class="overlay-title">{{ modules[currentModule].name }}</h3>
                    <p class="overlay-description">{{ modules[currentModule].description }}</p>
                  </div>
                </div>
              </div>

              <!-- Navigation Controls -->
              <div class="showcase-controls">
                <button
                  class="control-btn prev-btn"
                  @click="previousModule"
                  :disabled="currentModule === 0"
                >
                  <span class="material-symbols-outlined">chevron_left</span>
                </button>

                <div class="module-indicators">
                  <span
                    v-for="(module, index) in modules"
                    :key="index"
                    class="indicator"
                    :class="{ active: currentModule === index }"
                    @click="setCurrentModule(index)"
                  ></span>
                </div>

                <button
                  class="control-btn next-btn"
                  @click="nextModule"
                  :disabled="currentModule === modules.length - 1"
                >
                  <span class="material-symbols-outlined">chevron_right</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="pricing-header">
          <h2 class="pricing-title">{{ $t('pricingg') }}</h2>
          <p class="pricing-subtitle">{{ $t('pricingdescription') }}</p>
        </div>

        <div class="pricing-grid">
          <!-- Plan F-Basic -->
          <div class="pricing-card basic-plan">
            <div class="plan-header">
              <div class="plan-badge">{{ $t('pricing.plans.basic.title') }}</div>
              <div class="plan-price">
                <span class="price-amount">{{ $t('pricing.plans.basic.price') }}</span>
                <span class="price-period">/Mensuales</span>
              </div>
              <div class="plan-trial">{{ $t('pricing.plans.basic.trial') }}</div>
            </div>

            <div class="plan-features">
              <h4 class="features-title">{{ $t('pricing.plans.basic.includes') }}</h4>
              <ul class="features-list">
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Hasta 5 usuarios</span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Gestiona 20 activos</span>
                </li>

                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Modulo de gestión de activos</span>
                </li>

                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Modulo de gestión de Mantenimientos</span>
                </li>

                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Asignación de ordenes</span>
                </li>

                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Modulo de reportes basicos</span>
                </li>

                <li class="feature-item unavailable">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">close</span>
                  </span>
                  <span class="feature-text">Sin notificaciones inteligentes</span>
                </li>
                <li class="feature-item unavailable">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">close</span>
                  </span>
                  <span class="feature-text">Sin integraciónes IoT</span>
                </li>
              </ul>
            </div>

            <router-link to="/contact" class="plan-cta-link">
              <button class="plan-cta basic-cta">
                {{ $t('pricing.plans.basic.button') }}
              </button>
            </router-link>
          </div>

          <!-- Plan F-Pro (Featured) -->
          <div class="pricing-card pro-plan featured">
            <div class="featured-badge">Más Popular</div>
            <div class="plan-header">
              <div class="plan-badge">{{ $t('pricing.plans.pro.title') }}</div>
              <div class="plan-price">
                <span class="price-amount">{{ $t('pricing.plans.pro.price') }}</span>
                <span class="price-period">/Mensuales</span>
              </div>
              <div class="plan-trial">{{ $t('pricing.plans.pro.trial') }}</div>
            </div>

            <div class="plan-features">
              <h4 class="features-title">{{ $t('pricing.plans.pro.includes') }}</h4>
              <ul class="features-list">
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Hasta 20 usuarios</span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Gestiona 80 activos</span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Todo los modulos de F-Basic</span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Checklist personalizables por activo</span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text"
                    >Asignación de repuestos / insumos y servicios por activo</span
                  >
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text"
                    >Alertas y notificaciones de mantenimientos y documentos</span
                  >
                </li>
                <li class="feature-item unavailable">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">close</span>
                  </span>
                  <span class="feature-text">Sin integraciónes IoT</span>
                </li>
              </ul>
            </div>

            <router-link to="/contact" class="plan-cta-link">
              <button class="plan-cta pro-cta">
                {{ $t('pricing.plans.pro.button') }}
              </button>
            </router-link>
          </div>

          <!-- Plan F-Enterprise -->
          <div class="pricing-card enterprise-plan">
            <div class="plan-header">
              <div class="plan-badge">{{ $t('pricing.plans.enterprise.title') }}</div>
              <div class="plan-price">
                <span class="price-amount">{{ $t('pricing.plans.enterprise.price') }}</span>
                <span class="price-period">/Mensuales</span>
              </div>
              <div class="plan-trial">{{ $t('pricing.plans.enterprise.trial') }}</div>
            </div>

            <div class="plan-features">
              <h4 class="features-title">{{ $t('pricing.plans.enterprise.includes') }}</h4>
              <ul class="features-list">
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text"> Usuarios ilimitados </span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text"> Gestiona hasta 300 activos </span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Todos los modulos de F-Pro y F-Basic</span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Modulo de inventario</span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Control de costos por insumos y servicios</span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text"
                    >Integración con IoT (Gps, Sensores, MQTT, LoRaWAN, etc)</span
                  >
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">API para conexion a ERP y/o softwares contables</span>
                </li>
                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text">Modelo de recomendaciones basadas en datos</span>
                </li>

                <li class="feature-item available">
                  <span class="feature-icon">
                    <span class="material-symbols-outlined">check</span>
                  </span>
                  <span class="feature-text"
                    >Plataforma Web personalizable con logo y colores de marca</span
                  >
                </li>
              </ul>
            </div>

            <router-link to="/contact" class="plan-cta-link">
              <button class="plan-cta enterprise-cta">
                {{ $t('pricing.plans.enterprise.button') }}
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <router-link to="/contact">
      <div class="flex-center">
        <button class="demo">{{ $t('requestDemo') }}</button>
      </div>
    </router-link>
  </div>
</template>

<script lang="ts">
import transporteImg from '../assets/images/transporte.jpg'
import industryImg from '../assets/images/industry.jpg'
import energyImg from '../assets/images/energy.jpg'
import agroImg from '../assets/images/agro.jpg'
import dashboardImg from '../assets/images/dashboard.png'
import activosImg from '../assets/images/activos.png'
import alertasImg from '../assets/images/alertas.png'
import mantenimientosImg from '../assets/images/mantenimientos.png'
import tiemporealImg from '../assets/images/tiemporeal.png'

export default {
  data() {
    return {
      currentIndex: 0,
      services: [
        {
          title: 'Transporte  ',
          description: 'Transporte y logística: Monitoreo de flotas y rutas.',
          image: transporteImg,
        },
        {
          title: 'Industria',
          description: 'Optimización de maquinaria y equipos industriales.',
          image: industryImg,
        },
        {
          title: 'Energia y utilities',
          description: 'Supervisión de infraestructura crítica.',
          image: energyImg,
        },
        {
          title: 'Agricultura',
          description: 'Gestión de maquinaria y equipos agrícola.',
          image: agroImg,
        },
      ],
      currentModule: 0,
      modules: [
        {
          name: 'Dashboard',
          description:
            'Panel de control principal con métricas y análisis en tiempo real de todos tus activos.',
          image: dashboardImg,
          icon: 'dashboard',
        },
        {
          name: 'Activos',
          description:
            'Gestión completa del inventario de activos físicos y patrimoniales de tu empresa.',
          image: activosImg,
          icon: 'inventory',
        },
        {
          name: 'Alertas',
          description:
            'Sistema inteligente de notificaciones y alertas para mantenimiento preventivo.',
          image: alertasImg,
          icon: 'notifications',
        },
        {
          name: 'Mantenimientos',
          description:
            'Planificación, programación y seguimiento de todas las actividades de mantenimiento.',
          image: mantenimientosImg,
          icon: 'build',
        },
        {
          name: 'Tiempo Real',
          description:
            'Monitoreo en vivo del estado y ubicación de todos tus activos con IoT integrado.',
          image: tiemporealImg,
          icon: 'schedule',
        },
      ],
      autoPlayTimer: null as ReturnType<typeof setInterval> | null,
    }
  },
  mounted() {
    this.startAutoPlay()
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount() {
    this.stopAutoPlay()
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.services.length // Avanzar al siguiente servicio
    },
    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.services.length) % this.services.length // Retroceder al servicio anterior
    },
    goTo(index: number) {
      this.currentIndex = index // Navegar a un servicio específico
    },
    setCurrentModule(index: number) {
      this.currentModule = index
      this.resetAutoPlay()
    },
    previousModule() {
      this.currentModule = (this.currentModule - 1 + this.modules.length) % this.modules.length
      this.resetAutoPlay()
    },
    nextModule() {
      this.currentModule = (this.currentModule + 1) % this.modules.length
      this.resetAutoPlay()
    },
    onImageLoad() {
      // Handle image load event
    },
    startAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        this.currentModule = (this.currentModule + 1) % this.modules.length
      }, 5000) // Cambiar cada 5 segundos
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
        this.autoPlayTimer = null
      }
    },
    resetAutoPlay() {
      this.stopAutoPlay()
      this.startAutoPlay()
    },
    handleKeydown(event: KeyboardEvent) {
      if (event.key === 'ArrowLeft') {
        this.previousModule()
      } else if (event.key === 'ArrowRight') {
        this.nextModule()
      }
    },
  },
}
</script>

<style>
/* Variables CSS para la sección de precios */
:root {
  --primary-blue: #1297ef;
  --secondary-blue: #4ab7ff;
  --accent-blue: #00effd;
  --text-dark: #1a202c;
  --text-gray: #4a5568;
  --text-light: #718096;
  --bg-white: #ffffff;
  --bg-gray: #f7fafc;
  --bg-light: #edf2f7;
  --border-light: #e2e8f0;
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);
  --shadow-blue: 0 10px 30px rgba(18, 151, 239, 0.15);
  --shadow-blue-lg: 0 20px 40px rgba(18, 151, 239, 0.2);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;
}

/* Pricing Section */
.pricing-section {
  background: var(--bg-white);
  position: relative;
  padding: 4rem 0;
}

.pricing-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

.pricing-header {
  text-align: center;
  margin-bottom: 4rem;
}

.pricing-title {
  font-size: clamp(2.5rem, 4vw, 3.5rem);
  font-weight: 700;
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
}

.pricing-subtitle {
  font-size: clamp(1.1rem, 1.3vw, 1.3rem);
  color: var(--text-gray);
  margin: 0 auto;
  line-height: 1.6;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-top: 4rem;
}

/* Pricing Cards */
.pricing-card {
  background: var(--bg-white);
  border-radius: var(--radius-xl);
  padding: 2.5rem;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-light);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.pricing-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.pricing-card:hover::before {
  transform: scaleX(1);
}

.pricing-card:hover {
  transform: translateY(-12px);
  box-shadow: var(--shadow-xl);
  border-color: rgba(18, 151, 239, 0.2);
}

/* Featured Plan */
.pricing-card.featured {
  transform: scale(1.05);
  border: 2px solid var(--primary-blue);
  box-shadow: var(--shadow-blue);
}

.pricing-card.featured:hover {
  transform: scale(1.05) translateY(-12px);
  box-shadow: var(--shadow-blue-lg);
}

.featured-badge {
  position: absolute;
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  color: var(--bg-white);
  padding: 0.5rem 2rem;
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Plan Header */
.plan-header {
  text-align: center;
  margin-bottom: 2.5rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--border-light);
}

.plan-badge {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-dark);
  margin-bottom: 1rem;
  letter-spacing: -0.01em;
}

.plan-price {
  margin-bottom: 1rem;
}

.price-amount {
  font-size: 3rem;
  font-weight: 800;
  color: var(--primary-blue);
  letter-spacing: -0.02em;
}

.price-period {
  font-size: 1.1rem;
  color: var(--text-gray);
  font-weight: 500;
}

.plan-trial {
  font-size: 0.95rem;
  color: var(--text-light);
  font-weight: 500;
}

/* Plan Features */
.plan-features {
  margin-bottom: 2.5rem;
}

.features-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 1.5rem;
  letter-spacing: -0.01em;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 0;
  transition: all 0.2s ease;
}

.feature-item:hover {
  background: var(--bg-gray);
  margin: 0 -1rem;
  padding: 0.75rem 1rem;
  border-radius: var(--radius-sm);
}

.feature-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
}

.feature-item.available .feature-icon {
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  color: var(--bg-white);
}

.feature-item.unavailable .feature-icon {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.feature-text {
  font-size: 0.95rem;
  color: var(--text-dark);
  font-weight: 500;
  line-height: 1.4;
}

.feature-item.unavailable .feature-text {
  color: var(--text-light);
}

/* Plan CTA */
.plan-cta-link {
  text-decoration: none;
  display: block;
}

.plan-cta {
  width: 100%;
  padding: 1rem 2rem;
  border: none;
  border-radius: var(--radius-lg);
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;
}

.plan-cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.plan-cta:hover::before {
  left: 100%;
}

.basic-cta {
  background: var(--bg-light);
  color: var(--text-dark);
  border: 2px solid var(--border-light);
}

.basic-cta:hover {
  background: var(--primary-blue);
  color: var(--bg-white);
  border-color: var(--primary-blue);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.pro-cta {
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  color: var(--bg-white);
  box-shadow: var(--shadow-blue);
}

.pro-cta:hover {
  background: linear-gradient(135deg, var(--secondary-blue) 0%, var(--accent-blue) 100%);
  transform: translateY(-4px);
  box-shadow: var(--shadow-blue-lg);
}

.enterprise-cta {
  background: #002176;
  color: var(--bg-white);
  box-shadow: 0 10px 30px rgba(0, 33, 118, 0.15);
}

.enterprise-cta:hover {
  background: #001a5e;
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(0, 33, 118, 0.2);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .pricing-grid {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 1.5rem;
  }

  .pricing-card.featured {
    transform: none;
  }

  .pricing-card.featured:hover {
    transform: translateY(-12px);
  }
}

@media (max-width: 768px) {
  .pricing-section {
    padding: 6rem 0;
  }

  .pricing-container {
    padding: 0 1.5rem;
  }

  .pricing-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .pricing-card {
    padding: 2rem;
  }

  .price-amount {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .pricing-card {
    padding: 1.5rem;
  }

  .plan-header {
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
  }

  .price-amount {
    font-size: 2.2rem;
  }

  .plan-cta {
    padding: 0.9rem 1.5rem;
    font-size: 1rem;
  }
}

.texts {
  display: flex;
  flex-direction: column;
  margin: 0px 0px 0px 9%;
  width: 50%;
}

.control-carousel {
  font-size: 2.2em !important;
  color: #1297ef;
  display: flex !important;
  cursor: pointer;
  transition: 300ms linear;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  margin: 0px 5px;
  user-select: none;
}

.control-carousel:hover {
  border-radius: 50px;
  background-color: #1297ef2d;
}

.carousel-dot {
  width: 18px;
  height: 18px;
  background: #ccc;
  border-radius: 50%;
  border: none;
  margin: 0 3px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.carousel-dot:hover {
  background: #1297ef;
  transform: scale(1.1);
}

.carousel-dot.active {
  background: #1297ef;
  transform: scale(1.1);
}
.controls-carousel {
  display: flex;
  align-items: center;
  margin: 2em 0px 0px 0px;
  justify-content: center;
}

.expertise {
  display: flex;
  padding: 3em 0px;
  flex-direction: column;
}

.texts h2 {
  font-size: clamp(30px, 4vw, 80px);
  font-weight: 600;
  color: rgb(18 151 239);
}

.subtitle {
  font-size: clamp(30px, 4vw, 80px);
  font-weight: 600;
  color: #1297ef;
  line-height: 100%;
}

.carousel-photos {
  display: flex;
  flex-direction: row;
}
/* Mas imagenes */
.images {
  background-image: url(../assets/images/software.jpg);
  width: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  left: -3%;
  height: 350px;
  border-radius: 24px;
}

.price-item:hover {
  box-shadow: 0px 0px 10px #0003;
  transform: scale3d(1.05, 1.05, 1.05);
}
.icon-c {
  position: absolute;
  cursor: pointer;
  margin: 0 20px;
  color: #1297ef;
  font-size: 35px;
  user-select: none;
  background: transparent;
  border: none;
  transition: all 0.3s ease;
}

.icon-c:hover {
  color: #0d60ef;
  transform: scale(1.1);
}

.icon-class {
  cursor: pointer;
  position: absolute;
  right: 60px;
  color: #1297ef;
  font-size: 35px;
  user-select: none;
  background: transparent;
  border: none;
  transition: all 0.3s ease;
}

.icon-class:hover {
  color: #0d60ef;
  transform: scale(1.1);
}
.carousel-container {
  display: flex;
  width: 100%;
  align-items: center;
}
.photo-carousel {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
  background-size: cover;
  width: 100%;
  height: 500px;
  border-radius: 14px 14px 0px 0px;
  display: flex;
  background-position: center;
  align-items: flex-end;
  padding: 10px 20px;
  user-select: none;
}

.text-carousel {
  padding: 3em 20px;
}

.photo-carousel h1 {
  font-size: 30px;
  font-weight: 500;
  color: white;
}

.item-1 {
  box-shadow: 1px 0px 9px #0003;
  border-radius: 12px;
  margin: 1em 0px 2em 0px;
  width: -webkit-fill-available;
}

.text-card {
  padding: 2em 20px;
  height: 100px;
  border-radius: 0px 0px 14px 14px;
  background: white;
}

.text-carousel span {
  font-size: 18px;
  font-weight: 400;
  line-height: 100%;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

h3 {
  font-weight: 600;
}
.demo {
  background: #1297ef;
  border: none;
  height: 45px;
  width: 100%;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
  color: white;
  margin-top: 2em;
}
.main-pricing-title {
  background: linear-gradient(90deg, #08abff 8%, #0a5789 45%);
  color: transparent;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 40px;
  /* line-height: 100%; */
  font-weight: 500;
}
.pricing {
  display: flex;
}
.include {
  font-size: 16px;
  margin: 15px 0px;
  color: #575757;
}
.price {
  font-size: 24px;
  font-weight: normal;
}
.month {
  font-size: 12px;
  font-weight: 600;
}
.free {
  font-size: 12px;
}
.price-item {
  width: 32%;
  background: #ffffff;
  padding: 25px;
  border-radius: 10px;
  margin-top: 2em;
  box-shadow: 0px 4px 5px #0000001f;
  transition: all 0.3s;
}
.bloque:hover {
  box-shadow: 0px 0px 20px #0003;
  transform: scale(1.03);
  cursor: pointer;
}
.price-details {
  border-radius: 10px;
  background: #f9f9f9;
  padding: 25px 15px 15px;
}
.caracteristicas {
  display: flex;
  margin: 10px 0px;
}

.caracteristicas span {
  font-size: 14px;
}
.circle {
  min-width: 25px;
  min-height: 25px;
  background: aliceblue;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 10px 0px 0px;
}
.btn-basic {
  background: #d9d9d9;
  border: none;
  height: 35px;
  width: 100%;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
  margin-top: 10px;
}

.plan-title {
  font-size: 16px;
  font-weight: 700;
}

.gestion {
  font-size: 22px;
  font-weight: 500;
  line-height: 100%;
  margin: 0px 0px 10px 0px;
  color: #1297ef;
}
.integration {
  font-size: 22px;
  font-weight: 500;
  line-height: 100%;
  margin: 0px 0px 10px 0px;
  color: #1a3784;
}
.pencil {
  font-size: 22px;
  font-weight: 500;
  line-height: 100%;
  margin: 0px 0px 10px 0px;
  color: #1a3784;
}
.realtime {
  font-size: 22px;
  font-weight: 500;
  line-height: 100%;
  margin: 0px 0px 10px 0px;
  color: #1a3784;
}
.notification {
  font-size: 22px;
  font-weight: 500;
  margin: 0px 0px 10px 0px;
  line-height: 100%;
  color: #1297ef;
}

.truck {
  font-size: 22px;
  font-weight: 500;
  margin: 0px 0px 10px 0px;
  line-height: 100%;
  color: #1297ef;
}
.spacing-reverse {
  margin: 0px 50px 0px 0px;
  width: 50%;
}
.spacing-normal {
  margin: 0px 0px 0px 10px;
  width: 50%;
}

.spacing-normal span,
.spacing-reverse span {
  font-size: 16px;
  color: #0c1259;
  line-height: 18px;
  display: block;
  font-weight: 300;
}

.one {
  width: 50%;
}
.bloque {
  display: flex;
  margin: 3em 0px;
  align-items: center;
  border-radius: 20px;
  box-shadow: 0px 0px 5px #0003;
  width: 96%;
  height: 175px;
  transition: all 0.3s;
}

.bloque-reverse {
  display: flex;
  margin: 20px 0px;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.bloque1 {
  background-image: url(../assets/images/products/truck.png);
  width: 220px;
  height: 175px;

  background-size: contain;
  background-repeat: no-repeat;
}

.bloque2 {
  background-image: url(../assets/images/products/map.png);
  width: 220px;

  height: 175px;
  background-size: contain;
  background-repeat: no-repeat;
}

.bloque3 {
  background-image: url(../assets/images/products/notification.png);
  width: 220px;

  height: 175px;

  background-size: contain;
  background-repeat: no-repeat;
}

.bloque4 {
  background-image: url(../assets/images/products/calendar.png);
  width: 220px;

  height: 175px;

  background-size: contain;
  background-repeat: no-repeat;
}

.bloque5 {
  background-image: url(../assets/images/products/integration.png);
  width: 220px;
  height: 175px;
  background-size: contain;
  background-repeat: no-repeat;
}

.bloque6 {
  background-image: url(../assets/images/products/pencil.png);
  width: 220px;

  height: 175px;

  background-size: contain;
  background-repeat: no-repeat;
}

.main-container-details {
  padding: 3em;
}
.title-detail {
  background: linear-gradient(90deg, #08abff 8%, #0a5789 100%);
  color: transparent;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 40px;
  /*   line-height: 100%; */
  font-weight: 500;
  width: fit-content;
}

.title-detail span {
  font-size: large;
  color: gray;
  text-decoration: underline;
}

.flex-one {
  display: flex;
}

@media (width < 768px) {
  .flex-one {
    display: flex;
    flex-direction: column;
  }
  .one {
    width: 100%;
  }
  .main-container-details {
    padding: 1em;
  }
  .title-detail {
    background: linear-gradient(90deg, #08abff 8%, #0a5789 100%);
    color: transparent;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 35px;
    line-height: 100%;
    font-weight: 700;
    width: fit-content;
    margin: 1em;
  }
  .bloque1 {
    width: 107px;
    height: 80px;
  }

  .bloque2 {
    width: 107px;
    height: 80px;
  }

  .bloque3 {
    width: 107px;
    height: 80px;
  }

  .bloque4 {
    width: 107px;
    height: 80px;
  }

  .bloque5 {
    width: 107px;
    height: 80px;
  }

  .bloque6 {
    width: 107px;
    height: 80px;
  }

  .spacing-normal span,
  .spacing-reverse span {
    font-size: 12px;
  }

  .spacing-normal {
    width: -webkit-fill-available;
    padding: 0px 20px;
  }

  .bloque {
    display: flex;
    margin: 1em 0px;
    width: 100%;
    height: auto;
  }

  .realtime {
    font-size: 16px;
  }

  .notification {
    font-size: 16px;
  }

  .pencil {
    font-size: 16px;
  }

  .truck {
    font-size: 16px;
  }

  .integration {
    font-size: 16px;
  }

  .gestion {
    font-size: 16px;
  }

  .carousel-photos {
    display: flex;
    flex-direction: column;
  }

  .images {
    width: auto;
  }
  .texts {
    display: flex;
    flex-direction: column;
    margin: 20px;
    width: auto;
  }

  .controls-carousel {
    display: flex;
    align-items: center;
    margin: 2em 0px 0px 0px;
    justify-content: center;
  }
  .pricing {
    display: flex;
    flex-direction: column;
  }
  .price-item {
    width: auto;
    margin: 20px 20px !important;
  }
}

/* Image Showcase Section */
.image-showcase-section {
  margin-bottom: 6rem;
  padding: 4rem 0;
  background: linear-gradient(135deg, var(--bg-gray) 0%, var(--bg-white) 100%);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
}

.showcase-header {
  text-align: center;
  margin-bottom: 3rem;
}

.showcase-title {
  font-size: clamp(2rem, 3vw, 2.8rem);
  font-weight: 700;
  color: var(--primary-blue);
  margin-bottom: 1rem;
  letter-spacing: -0.02em;
}

.showcase-subtitle {
  font-size: clamp(1rem, 1.2vw, 1.2rem);
  color: var(--text-gray);
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.6;
}

.showcase-content {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Navigation Tabs */
.showcase-tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.tab-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  background: var(--bg-white);
  border: 2px solid var(--border-light);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-gray);
  box-shadow: var(--shadow-sm);
}

.tab-button:hover {
  border-color: var(--primary-blue);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.tab-button.active {
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  border-color: var(--primary-blue);
  color: var(--bg-white);
  transform: translateY(-2px);
  box-shadow: var(--shadow-blue);
}

.tab-icon {
  font-size: 1.2rem;
}

.tab-label {
  font-weight: 600;
  letter-spacing: 0.3px;
}

/* Image Display */
.showcase-display {
  position: relative;
}

.image-container {
  position: relative;
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-xl);
  background: var(--bg-white);
  aspect-ratio: 16/10;
}

.showcase-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.showcase-image:hover {
  transform: scale(1.02);
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 3rem 2rem 2rem;
  transform: translateY(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.image-container:hover .image-overlay {
  transform: translateY(0);
}

.overlay-content {
  color: var(--bg-white);
}

.overlay-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  letter-spacing: -0.01em;
}

.overlay-description {
  font-size: 1rem;
  line-height: 1.5;
  opacity: 0.9;
}

/* Navigation Controls */
.showcase-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
}

.control-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid var(--border-light);
  background: var(--bg-white);
  color: var(--text-gray);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  box-shadow: var(--shadow-sm);
}

.control-btn:hover:not(:disabled) {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.control-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.module-indicators {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--border-light);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background: var(--primary-blue);
  transform: scale(1.3);
}

.indicator:hover {
  background: var(--secondary-blue);
  transform: scale(1.2);
}

/* Responsive Design for Showcase */
@media (max-width: 768px) {
  .image-showcase-section {
    margin-bottom: 4rem;
    padding: 3rem 0;
  }

  .showcase-content {
    padding: 0 1.5rem;
  }

  .showcase-tabs {
    gap: 0.5rem;
  }

  .tab-button {
    padding: 0.8rem 1rem;
    font-size: 0.9rem;
  }

  .tab-label {
    display: none;
  }

  .tab-icon {
    font-size: 1.4rem;
  }

  .image-overlay {
    padding: 2rem 1.5rem 1.5rem;
  }

  .overlay-title {
    font-size: 1.3rem;
  }

  .overlay-description {
    font-size: 0.9rem;
  }

  .showcase-controls {
    gap: 1rem;
  }

  .control-btn {
    width: 45px;
    height: 45px;
    font-size: 1.3rem;
  }
}
</style>
